exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".el-header[data-v-e4f8f1f8]{padding:0 3.2rem}.el-aside[data-v-e4f8f1f8]{background:#f9fafc;padding:4.8rem 2.4rem}.el-main[data-v-e4f8f1f8]{padding:0 20px 20px}.initial-setting-right[data-v-e4f8f1f8]{background:#fff}", ""]);

